import { ReactNode } from 'react';
import css from './index.module.scss';
import { Typography } from '@components/base';

interface BoxContainerProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  headerRight?: ReactNode;
}

const BoxContainer = (props: BoxContainerProps) => {
  const { title, children, className, headerRight } = props;
  return (
    <div className={`${css.accordionWrapper} ${className}`}>
      <div className={css.accordionHeaderWrapper}>
        <Typography variant="h4">{title}</Typography>
        {headerRight ? <div className={css.headerRight}>{headerRight}</div> : null}
      </div>
      <div className={css.accordionContentWrapper}>{children}</div>
    </div>
  );
};

export default BoxContainer;
